import { Navigate } from 'react-router-dom'
import { defaultLandingPathForDesk } from '@/config/workspace-desk-routes'
import { resolveWorkspaceDeskFromHost } from '@/config/workspace-desk'
import { useMeSessionQuery } from '@/features/auth/hooks/use-me-session-query'
import { AuthLoadingScreen } from '@/features/auth/components/require-auth'

/** Index route under the authenticated shell — desk hosts land on their hub. */
export function WorkspaceDeskLandingRedirect() {
  const desk = resolveWorkspaceDeskFromHost(window.location.hostname)
  const session = useMeSessionQuery()

  if (session.isPlaceholderData || (session.isPending && session.data === undefined)) {
    return <AuthLoadingScreen />
  }

  return (
    <Navigate
      to={defaultLandingPathForDesk(
        desk,
        session.data?.roles ?? [],
        session.data?.capabilities ?? [],
      )}
      replace
    />
  )
}
